import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  MenuItem,
  Button,
  Typography,
  Modal,
  Box,
  IconButton,
  Snackbar,
  Alert,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import UploadIcon from "@mui/icons-material/Upload";
import axiosInstance from "../../../API/axiosInstance";
import * as XLSX from "xlsx";

const CreateUser  = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = localStorage.getItem("token");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);
  const [open, setOpen] = useState(false);
  const [bulkModalOpen, setBulkModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isSuccessSnackbar, setIsSuccessSnackbar] = useState(false);

  const handleDownloadTemplate = () => {
  const worksheetData = [
    [
      "firstName",
      "lastName",
      "address",
      "email",
      "phone",
      "vehicleNumber",
      "gender",
      "dateOfBirth",
      "clientEmployeeId",
    ],
    ["", "", "", "", "", "", "", "", ""],
  ];

  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

  XLSX.writeFile(workbook, "Create_User_Template.xlsx");
};
  const getMaxDOB = () => {
  const today = new Date();
  today.setFullYear(today.getFullYear() - 18);
  return today.toISOString().split("T")[0]; // yyyy-mm-dd
};
  const handleFileChange = (event: any) => {
    setSelectedFile(event.target.files[0]);
  };
  const handleBulkUpload = async () => {
    if (!selectedFile) {
      setSnackbarMessage("Please select a file before submitting.");
      setShowErrorSnackbar(true);
      return;
    }

    const formData = new FormData();
    formData.append("fileItem", selectedFile);

    try {
      const response = await axiosInstance.post(
        "/auth/bulk-upload/user",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response?.status === 200) {
        setBulkModalOpen(false);
        setSnackbarMessage("File uploaded successfully.");
        setIsSuccessSnackbar(true);
        setShowErrorSnackbar(true);

        setTimeout(() => {
          navigate("/userdetails", { state: { tabIndex: 1 } });
        }, 3000); // Delay of 3 seconds
      } else {
        setSnackbarMessage(response.data?.message || "Error uploading file.");
      }
    } catch (error) {
      console.error("Bulk upload error:", error);
      setSnackbarMessage("Failed to upload file. Please try again.");
    } finally {
      setShowErrorSnackbar(true);
    }
  };

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    address: "",
    email: "",
    phone: "",
    vehicleNumber: "",
    gender: "",
    dateOfBirth: "",
    clientEmployeeId: "",
  });

  const [errors, setErrors] = useState<{ phone?: string }>({});

  const validateMobile = (mobile: string) => /^[6-9]\d{9}$/.test(mobile);
  const handleBackToDashboard = () => {
    navigate("/userdetails"); // Navigate back to Dashboard with EV Details tab active
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name === "phone") {
      // Allow only numbers and limit to 10 digits
      const numericValue = value.replace(/\D/g, "").slice(0, 10);
      setFormData((prev) => ({ ...prev, [name]: numericValue }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    let validationErrors: { phone?: string } = {};

    if (!validateMobile(formData.phone)) {
      validationErrors.phone = "Enter a valid mobile number";
    }
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setIsSubmitting(true);
    }
  };

  useEffect(() => {
    if (isSubmitting) {
      const createUser = async () => {
        try {
          const response = await axiosInstance.post(
            "/auth/dashboard/user/create",
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );

          if (response?.status === 200) {
            setOpen(true);
            setTimeout(() => {
              setOpen(false);
              navigate("/userdetails", { state: { tabIndex: 1 } });
            }, 5000);
          } else {
            setSnackbarMessage(response.data?.message || "Error creating user");
            setShowErrorSnackbar(true);
          }
        } catch (error) {
          console.error("API call error:", error);
          if (axios.isAxiosError(error) && error.response) {
            setSnackbarMessage(
              error.response.data?.message ||
                "Failed to create user. Please try again."
            );
          } else {
            setSnackbarMessage("Network error or server unreachable.");
          }
          setShowErrorSnackbar(true);
        } finally {
          setIsSubmitting(false); // Reset button state
        }
      };
      createUser();
    }
  }, [navigate,isSubmitting, formData, token]);

  return (
    <div>
      
      <div className="flex bg-white min-h-80 box-shadow p-3 rounded-xl mx-16 mt-10">
        <div className="w-full">
          <Grid
            container
            spacing={5}
            className="w-full flex justify-between items-center"
          >
            <Grid item md={3}>
              <div className="flex ml-4">
                <h2 className="text-center ml-2 mx-1 mt-2 font-semibold text-2xl text-black pb-2">
                  <IconButton onClick={handleBackToDashboard}>
                    <ArrowBackIcon />
                  </IconButton>
                  New Rider Detail
                </h2>
              </div>
            </Grid>
            <Grid item md={9} className="flex justify-end align-center">
              <Button
                onClick={() => setBulkModalOpen(true)}
                style={{
                  backgroundColor: "#00cd5b",
                  color: "#fff",
                  borderRadius: "40px",
                  marginRight: "10px",
                }}
              >
                <UploadIcon /> Bulk Upload
              </Button>

              <Button
                onClick={handleDownloadTemplate}
                type="submit"
                style={{
                  backgroundColor: "#00cd5b",
                  padding: "5px 10px",
                  color: "#fff",
                  borderRadius: "40px",
                  textTransform: "none",
                  fontSize: "16px",
                }}
              >
                <DownloadIcon /> Download Template
              </Button>
            </Grid>
          </Grid>
          <hr className="my-4" />

          <form onSubmit={handleSubmit} className="p-8">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="First Name"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  variant="standard"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Last Name"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  variant="standard"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  variant="standard"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  variant="standard"
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} className="pt-10">
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Mobile No."
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  error={!!errors.phone}
                  helperText={errors.phone}
                  variant="standard"
                  inputProps={{
                    inputMode: "numeric", // Ensures numeric keypad on mobile
                    pattern: "[0-9]*", // Restricts to numbers only
                    maxLength: 10, // Does NOT work with type="number" (we'll handle it manually)
                    min: 0, // Prevents negative numbers
                  }}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                      e.preventDefault(); // Prevent invalid characters
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Vehicle Number"
                  name="vehicleNumber"
                  value={formData.vehicleNumber}
                  onChange={handleChange}
                  variant="standard"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  fullWidth
                  label="Gender"
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  variant="standard"
                >
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
  name="dateOfBirth"
  label="Date of Birth"
  type="date"
  InputLabelProps={{ shrink: true }}
  value={formData.dateOfBirth}
  onChange={handleChange}
  fullWidth
  variant="standard"
  inputProps={{
    max: getMaxDOB(), // 👈 only 18+ allowed
  }}
/>

              </Grid>
            </Grid>
             <Grid container spacing={2} className="pt-10 flex justify-between">
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Employee ID"
                  name="clientEmployeeId"
                  value={formData.clientEmployeeId}
                  onChange={handleChange}
                  variant="standard"
                />
              </Grid>
              <Grid item xs={2}>
                <Button
                  type="submit"
                  disabled={isSubmitting}
                  style={{
                    backgroundColor: "#000",
                    padding: "5px 18px",
                    color: "#fff",
                    borderRadius: "40px",
                    width: "100%",
                    textTransform: "none",
                    fontSize: "16px",
                  }}
                >
                  {isSubmitting ? "Creating..." : "Create Rider"}
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
      </div>
      <Modal open={bulkModalOpen} onClose={() => setBulkModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            p: 4,
            borderRadius: 2,
            boxShadow: 24,
          }}
        >
          <IconButton
            sx={{ position: "absolute", top: 8, right: 8 }}
            onClick={() => setBulkModalOpen(false)}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6">Bulk Upload</Typography>
          <input
            type="file"
            accept=".xlsx"
            onChange={handleFileChange}
            style={{ marginTop: 16 }}
          />
          {/* {selectedFile && <Typography variant="body2" sx={{ mt: 1 }}>{selectedFile}</Typography>} */}
          <Button
            onClick={handleBulkUpload}
            variant="contained"
            sx={{
              mt: 2,
              backgroundColor: "#000",
              color: "#fff",
              borderRadius: "40px",
            }}
          >
            Submit
          </Button>
        </Box>
      </Modal>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 350,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
            textAlign: "center",
          }}
        >
          <IconButton
            sx={{ position: "absolute", top: 8, right: 8 }}
            onClick={() => setOpen(false)}
          >
            <CloseIcon />
          </IconButton>
          <Box
            sx={{
              width: 60,
              height: 60,
              backgroundColor: "#00C853",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "auto",
            }}
          >
            <Typography sx={{ fontSize: 40, color: "white" }}>✔</Typography>
          </Box>
          <Typography variant="h6" sx={{ mt: 2 }}>
            New User Added Successfully!
          </Typography>
          <Button
            variant="contained"
            sx={{
              mt: 3,
              backgroundColor: "#000",
              color: "#fff",
              borderRadius: "40px",
            }}
            onClick={() => setOpen(false)}
          >
            Continue to Dashboard
          </Button>
        </Box>
      </Modal>

      <Snackbar
        open={showErrorSnackbar}
        autoHideDuration={6000}
        onClose={() => setShowErrorSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          severity={isSuccessSnackbar ? "success" : "error"}
          sx={{
            backgroundColor: isSuccessSnackbar ? "#4caf50" : "#f44336",
            color: "#fff",
            display: "flex",
            alignItems: "center",
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CreateUser;
